import auth from '@/router/auth'
import CategoryItemIndex from '@/components/category-items/Index'
import CategoryItemCreate from '@/components/category-items/Create'
import CategoryItemUpdate from '@/components/category-items/Update'
import CategoryItemShow from '@/components/category-items/Show'

export default [
  {
    path: '/category-items',
    name: 'category-items-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-items/create',
    name: 'category-items-create',
    component: CategoryItemCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-items/update/:id',
    name: 'category-items-update',
    component: CategoryItemUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/category-items/show/:id',
    name: 'category-items-show',
    component: CategoryItemShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/category-items/router.js